import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    standalone: false
})
export class InitialsPipe implements PipeTransform {
    transform(fullName: any, ...args: any[]): any {
        if (fullName) {
            const splittedName = fullName.trim().split(' ');

            if (splittedName.length === 1) {
                return splittedName[0][0];
            } else {
                return splittedName.map(x => x[0]).join('');
            }
        } else {
            return '';
        }
    }
}
